import { create } from 'zustand'
import { IS_DEV } from '@/common/env'
import { SIX_DEV_FLAG_OVERRIDES } from '@/common/storage/keys'

type FlagValue = boolean | string
type Overrides = Record<string, FlagValue>

interface DevOverrideState {
    overrides: Overrides
    setOverride: (key: string, value: FlagValue) => void
    clearOverride: (key: string) => void
    getOverride: (key: string) => FlagValue | undefined
}

const getInitialOverrides = (): Overrides => {
    if (!IS_DEV || typeof window === 'undefined') return {}
    try {
        const raw = localStorage.getItem(SIX_DEV_FLAG_OVERRIDES)
        const parsed: unknown = raw ? JSON.parse(raw) : {}
        return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed) ? (parsed as Overrides) : {}
    } catch {
        return {}
    }
}

const persistOverrides = (overrides: Overrides) => {
    if (!IS_DEV || typeof window === 'undefined') return
    try {
        localStorage.setItem(SIX_DEV_FLAG_OVERRIDES, JSON.stringify(overrides))
    } catch {
        // ignore
    }
}

const useDevOverrideStore = create<DevOverrideState>((set, get) => ({
    overrides: getInitialOverrides(),

    setOverride: (key, value) => {
        const overrides = { ...get().overrides, [key]: value }
        persistOverrides(overrides)
        set({ overrides })
    },

    clearOverride: (key) => {
        const overrides = { ...get().overrides }
        delete overrides[key]
        persistOverrides(overrides)
        set({ overrides })
    },

    getOverride: (key) => get().overrides[key],
}))

export default useDevOverrideStore
